import notification from "common/utils/notification"
import { normalizeString } from "common/utils/utils"
import { excelToJson, extractImportObject } from "features/Importar/utils"
import { useCallback, useState } from "react"
import { useTranslation } from "react-i18next"

const useImportGrid = ({ options }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [data, setData] = useState([])
  const [header, setHeader] = useState([])
  const [selectedOptions, setSelectedOptions] = useState(null)
  const [fetching, setFetching] = useState(false)

  const handleSetData = useCallback(
    async (file: $TSMigrationFixMe) => {
      const data = await excelToJson(file)
      // @ts-expect-error TS(2345): Argument of type '{}[]' is not assignable to param...
      setData(data.slice(0, data?.length))

      setHeader(
        // @ts-expect-error TS(2345): Argument of type '{ header: string; initialDropdow...
        Object.keys(data?.[0] || {}).map((header) => ({
          header: `${header?.charAt(0).toUpperCase()}${header?.slice(1)}`,
          initialDropdownValue:
            options.find((o: { label: string; value: string }) => {
              const isMatch =
                normalizeString(header.toLowerCase()) ===
                  normalizeString(o.value.toLowerCase()) ||
                normalizeString(header.toLowerCase()) ===
                  normalizeString(o.label.toLowerCase())

              return isMatch
            })?.value || "",
          type: "text",
        }))
      )
    },
    [options]
  )

  const handleUpload = useCallback(
    async (postFn: $TSMigrationFixMe) => {
      const extractedObj = extractImportObject({
        data,
        selectedOptions,
      })

      if (!extractedObj.length) {
        return notification.warning({
          body: `${t("notification.noFieldSelected")}`,
        })
      }

      setFetching(true)
      try {
        await postFn(extractedObj)
        setFetching(false)
        return true
      } catch (e) {
        setFetching(false)
      }
    },
    [data, selectedOptions, t]
  )

  return {
    header,
    data,
    setData,
    selectedOptions,
    fetching,
    handleSetData,
    handleUpload,
    setSelectedOptions,
  }
}

export default useImportGrid
